module.exports = __webpack_public_path__ + "img/terroir-liquify-2.c0b6961e.jpg";